import { Navigate, Route, Routes } from 'react-router';
import { RequireClient } from './components/RequireClient.js';
import { Shell } from './components/Shell.js';
import { LoginPage } from './routes/LoginPage.js';
import { HomePage } from './routes/HomePage.js';
import { InvoicesPage } from './routes/InvoicesPage.js';
import { InvoiceDetailPage } from './routes/InvoiceDetailPage.js';
import { PaymentSuccessPage } from './routes/PaymentSuccessPage.js';
import { PaymentFailedPage } from './routes/PaymentFailedPage.js';
import { EditRequestsPage } from './routes/EditRequestsPage.js';
import { NewEditRequestPage } from './routes/NewEditRequestPage.js';
import { FilesPage } from './routes/FilesPage.js';
import { ProfilePage } from './routes/ProfilePage.js';
import { NotFoundPage } from './routes/NotFoundPage.js';

/* ============================================================================
   Routes.
   ----------------------------------------------------------------------------
   Everything except /login sits inside <RequireClient>, which is a courtesy
   and not a security boundary: every endpoint behind it checks the session
   itself, because anyone can edit the JavaScript running on their own phone.

   The payment result pages are outside the shell's navigation but inside the
   login, because Razorpay redirects back to them and the person landing there
   is mid-transaction — a bottom nav is not what they need to see.
   ========================================================================== */

export function App() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />

      <Route
        element={
          <RequireClient>
            <Shell />
          </RequireClient>
        }
      >
        <Route path="/" element={<HomePage />} />
        <Route path="/invoices" element={<InvoicesPage />} />
        <Route path="/invoices/:id" element={<InvoiceDetailPage />} />
        <Route path="/edit-requests" element={<EditRequestsPage />} />
        <Route path="/edit-requests/new" element={<NewEditRequestPage />} />
        <Route path="/files" element={<FilesPage />} />
        <Route path="/profile" element={<ProfilePage />} />
      </Route>

      <Route
        element={
          <RequireClient>
            <Shell bare />
          </RequireClient>
        }
      >
        <Route path="/payment/success" element={<PaymentSuccessPage />} />
        <Route path="/payment/failed" element={<PaymentFailedPage />} />
      </Route>

      <Route path="/index.html" element={<Navigate to="/" replace />} />
      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  );
}
